
import apiClient from "@/shared/services/api/apiClient";
import type { CandidateProfileData } from "../types/candidateProfile.types";

const PROFILE_ENDPOINT = "/candidate/profile";
const PROFILE_VIDEO_ENDPOINT = `${PROFILE_ENDPOINT}/video`;
const PROFILE_RESUME_ENDPOINT = `${PROFILE_ENDPOINT}/resume`;

type CandidateProfileApiResponse = {
  success: boolean;
  data: CandidateProfileData;
  message?: string;
};

type CandidateProfileVideoApiResponse = {
  success: boolean;
  message?: string;
  data: {
    video: NonNullable<CandidateProfileData["video"]>;
  };
};

type CandidateProfileResumeApiResponse = {
  success: boolean;
  message?: string;
  data: {
    resume: NonNullable<CandidateProfileData["resume"]>;
  };
};

export const getCandidateProfile = async (): Promise<{
  data: CandidateProfileData;
}> => {
  const response = await apiClient.get(PROFILE_ENDPOINT);
  const result = response.data as CandidateProfileApiResponse;

  return {
    data: result.data,
  };
};

export const updateCandidateProfile = async (
  payload: Partial<
    Pick<
      CandidateProfileData,
      | "designation"
      | "phone"
      | "location"
      | "about"
      | "skills"
      | "experience"
      | "education"
    >
  >
): Promise<{ data: CandidateProfileData }> => {
  const response = await apiClient.put(PROFILE_ENDPOINT, payload);
  const result = response.data as CandidateProfileApiResponse;

  return {
    data: result.data,
  };
};

export const uploadCandidateProfileVideo = async (
  file: File
): Promise<{
  video: NonNullable<CandidateProfileData["video"]>;
  message?: string;
}> => {
  const formData = new FormData();
  formData.append("video", file);

  const response = await apiClient.post(
    PROFILE_VIDEO_ENDPOINT,
    formData
  );

  const result = response.data as CandidateProfileVideoApiResponse;

  return {
    video: result.data.video,
    message: result.message,
  };
};

export const uploadCandidateProfileResume = async (
  file: File
): Promise<{
  resume: NonNullable<CandidateProfileData["resume"]>;
  message?: string;
}> => {
  const formData = new FormData();
  formData.append("resume", file);

  const response = await apiClient.post(
    PROFILE_RESUME_ENDPOINT,
    formData
  );

  const result = response.data as CandidateProfileResumeApiResponse;

  return {
    resume: result.data.resume,
    message: result.message,
  };
};
